import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mqcdAPI } from '@api/modules/mqcd';
import { optnAPI } from '@api/modules/optn';
import { mdrlAPI } from '@api/modules/mdrl';
import { suppAPI } from '@api/modules/supp';
import { colrAPI } from '@/api/modules/colr.js';
import addHeader from '@/views/component/addHeader';
import inputUser from '@/views/component/inputUser';
import MqcdMtrlImport from '@/views/StockManagement/MqcdManage/TabChild/Componet/MqcdMtrlImport.vue';
import MqcdSourImport from '@/views/StockManagement/MqcdManage/TabChild/Componet/MqcdSourImport.vue';
import MqcdAddMtrl from '@/views/StockManagement/MqcdManage/TabChild/Componet/MqcdAddMtrl.vue';
import helper from '@assets/js/helper';
import { imgeAPI } from '@api/modules/imge';
import imgPopover from '@/views/component/imgPopover.vue'; // import MtrlImport from "./Componet/MdrlImport.vue"

export default {
  name: 'mqcdAddMain',
  components: {
    addHeader: addHeader,
    inputUser: inputUser,
    MqcdMtrlImport: MqcdMtrlImport,
    MqcdSourImport: MqcdSourImport,
    MqcdAddMtrl: MqcdAddMtrl,
    imgPopover: imgPopover
  },
  created: function created() {
    this.initData();
  },
  watch: {},
  data: function data() {
    return {
      uploadUrl: helper.modePrepend(imgeAPI.uploadImage),
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400
      },
      mqcdForm: {
        mdrl_id: null,
        sour_mdrl_id: null,
        sour_no: null,
        mdrl_no: null,
        mdrl_name: null,
        mdrl_unit: null,
        mdrl_type: 0,
        mqcd_num: null,
        mqcd_bin: null,
        user_id: null,
        stff_id: null,
        dept_id: null,
        status: 0,
        mdrl_spec: '',
        mdrl_color: '',
        mdrl_weight: '',
        mdrl_width: null,
        imge_id: null,
        imge_url: '',
        imge_urlO: '',
        mdrl_thick: null,
        mdrl_comp: null,
        mdrl_stock_limit: 0,
        mdrl_prod_price: '',
        mdrl_remark: '',
        supp_id: '',
        colr_class: '',
        key: 0,
        belo_dept_id: null //所属部门

      },
      binList: [],
      mdrlType: [{
        id: 1,
        label: '主材料'
      }, {
        id: 2,
        label: '辅材料'
      }, {
        id: 3,
        label: '其他'
      }],
      mdrlTypeGroupOpt: [],
      suppType: [],
      mdrlFlag: false,
      sourFlag: false,
      title: '材料信息',
      title1: '采购信息',
      option: [],
      binListCopy: [],
      disableMtrlAdd: true,
      disableMtrlType: true,
      disableMtrlColorClass: true,
      emptyDisable: false,
      optnColorList: []
    };
  },
  methods: {
    initData: function initData() {
      this.getMqcdType();
      this.getBinList();
      this.getDepartment();
      this.getSuppsList();
    },
    // 获取供应商信息
    getSuppsList: function getSuppsList() {
      var _this = this;

      get(suppAPI.getSuppsV1).then(function (res) {
        if (res.data.code === 0) {
          _this.suppType = res.data.data;
        }
      });
    },
    // 商户下拉框下拉
    suppChange: function suppChange() {
      this.getSuppsList();
    },
    // 获取库位信息
    getBinList: function getBinList() {
      var _this2 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10006
      }).then(function (res) {
        if (res.data.code === 0) {
          _this2.binList = res.data.data;
          _this2.binListCopy = JSON.parse(JSON.stringify(res.data.data));
        }
      });
    },
    // 获取单位
    getMqcdType: function getMqcdType() {
      var _this3 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10005
      }).then(function (res) {
        if (res.data.code === 0) {
          _this3.mdrlTypeGroupOpt = res.data.data;
        }
      });
    },
    //获取打样部门
    getDepartment: function getDepartment() {
      var _this4 = this;

      get(optnAPI.getOptnByPermId, {
        perm_id: 10009
      }).then(function (res) {
        if (res.data.code === 0) {
          var arr = [];
          res.data.data.form.optn_cntt_list.forEach(function (item) {
            arr.push({
              value: item.param2,
              label: item.param1
            });
          });
          _this4.option = arr;
          return;
        }

        _this4.$message.error(res.data.msg);
      });
    },
    //提交表单
    submit: function submit(formName) {
      var _this5 = this;

      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.$refs[formName].validate(function (valid) {
          if (valid) {
            if (_this5.disableMtrlAdd) {
              _this5.saveInfo();
            } else {
              _this5.saveInfoC();
            }
          } else {
            _this5.$message({
              type: 'warning',
              message: '请填入必填信息'
            });

            console.log('error submit!');
            return false;
          }
        });
      }).catch(function () {});
    },
    // 保存
    saveInfo: function saveInfo() {
      var _this6 = this;

      var staffForm = this.$refs.userData.getData();
      var mqcdForm = {};
      var mqcdFormCopy = JSON.parse(JSON.stringify(this.mqcdForm));
      mqcdForm = Object.assign(mqcdFormCopy, staffForm);
      delete mqcdForm.status;

      if (mqcdForm.mdrl_type === 0) {
        mqcdForm.mdrl_no = mqcdForm.mdrl_no + mqcdForm.mdrl_color + 'C';
        mqcdForm.mdrl_color = mqcdForm.mdrl_color + 'C';
      } else {
        // mqcdForm.mdrl_no = mqcdForm.mdrl_no
        mqcdForm.mdrl_color = '';
      }

      post(mqcdAPI.addMqcd, mqcdForm).then(function (res) {
        if (res.data.code === 0) {
          _this6.$message({
            type: 'success',
            message: '保存成功'
          });

          var permId = _this6.$route.query.perm_id;

          _this6.jump("/mqcd_list?perm_id=".concat(permId));

          _this6.resetForm('mqcdForm');
        } else if (res.data.code === 7) {
          _this6.$message({
            type: 'error',
            message: '库位中已有此材料'
          });
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this6.$message({
            message: mg,
            type: tp
          });

          _this6.initData();
        }
      });
    },
    saveInfoC: function saveInfoC() {
      var _this7 = this;

      var staffForm = this.$refs.userData.getData();
      var mqcdForm = {};
      var mqcdFormCopy = JSON.parse(JSON.stringify(this.mqcdForm));
      mqcdForm = Object.assign(mqcdFormCopy, staffForm);

      if (mqcdForm.mdrl_type === 0) {
        mqcdForm.mdrl_no = mqcdForm.mdrl_no + mqcdForm.mdrl_color + 'C';
        mqcdForm.mdrl_color = mqcdForm.mdrl_color + 'C';
      } else {
        mqcdForm.mdrl_color = '';
      }

      mqcdForm.mdrl_id = null;
      post(mqcdAPI.addMtrlToMqcd, mqcdForm).then(function (res) {
        if (res.data.code === 0) {
          _this7.$message({
            type: 'success',
            message: '保存成功'
          });

          var permId = _this7.$route.query.perm_id;

          _this7.jump("/mqcd_list?perm_id=".concat(permId));

          _this7.resetForm('mqcdForm');
        } else if (res.data.code === 7) {
          _this7.$message({
            type: 'error',
            message: '库位中已有此材料'
          });
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this7.$message({
            message: mg,
            type: tp
          });

          _this7.initData();
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this7.$message({
          message: mg,
          type: tp
        });
      });
    },
    //取消
    cancel: function cancel() {
      var _this8 = this;

      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this8.resetForm('mqcdForm');

        _this8.$message({
          type: 'info',
          message: '已取消新增!'
        });
      }).catch(function () {});
    },
    // 新增字表数据
    addRow: function addRow() {
      var temp = {};

      if (this.mqcdForm.supp_id) {
        temp.supp_id = this.mqcdForm.supp_id;
      } else {
        temp.supp_id = null;
      }

      if (this.mqcdForm.mdrl_prod_price) {
        temp.mdrl_prod_price = this.mqcdForm.mdrl_prod_price;
      } else {
        temp.mdrl_prod_price = '0.0000';
      }

      temp.mdrl_info_checked = false;
      temp.key = this.mqcdForm.mdrl_info_list.length;
      this.mqcdForm.mdrl_info_list.push(temp);
    },
    // 材料类型变化
    mdrlTypeChange: function mdrlTypeChange(value) {
      this.mqcdForm.mdrl_name = null;

      if (value === 0) {
        this.disableMtrlType = true;
      } else {
        this.disableMtrlType = false;
        this.mqcdForm.mdrl_color = '';
      }
    },
    // 保留位数
    baretaino: function baretaino() {
      this.mqcdForm.mdrl_no = this.mqcdForm.mdrl_no.substr(0, 2);
      this.mqcdForm.mdrl_thick = this.helper.reservedDigits(this.mqcdForm.mdrl_thick);
      this.mqcdForm.mdrl_width = this.helper.reservedDigits(this.mqcdForm.mdrl_width);
      this.mqcdForm.mdrl_prod_price = this.helper.haveFour(this.mqcdForm.mdrl_prod_price);
      this.mqcdForm.mdrl_weight = this.helper.reservedDigits(this.mqcdForm.mdrl_weight);
      this.mqcdForm.mdrl_color = this.mqcdForm.mdrl_color.substring(0, this.mqcdForm.mdrl_color.indexOf('C'));
    },
    // 调用匹配接口
    getMtrlByInfo: function getMtrlByInfo() {
      var _this9 = this;

      var params = {};
      params.mdrl_type = this.mqcdForm.mdrl_type;
      params.mdrl_no = this.mqcdForm.mdrl_no;

      if (this.mqcdForm.mdrl_type === 0) {
        params.mdrl_width = this.mqcdForm.mdrl_width;
        params.mdrl_color = this.mqcdForm.mdrl_color + 'C';
        params.mdrl_thick = this.mqcdForm.mdrl_thick;
        params.mdrl_weight = this.mqcdForm.mdrl_weight;
      } else {
        params.mdrl_name = this.mqcdForm.mdrl_name;
        params.mdrl_spec = this.mqcdForm.mdrl_spec;
      }

      get(mdrlAPI.getMtrlByInfo, params).then(function (res) {
        if (res.data.code === 0) {
          var form = res.data.data.form;
          _this9.mqcdForm = Object.assign(_this9.mqcdForm, form);
          var urlEng = JSON.parse(JSON.stringify(_this9.mqcdForm.imge_url));
          var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
          _this9.mqcdForm.imge_url = _this9.helper.picUrl(urlEng, 's', updateTime);
          _this9.mqcdForm.imge_urlO = _this9.helper.picUrl(urlEng, 'l', updateTime);

          if (!form.colr_class) {
            _this9.disableMtrlColorClass = false;
          } else {
            _this9.disableMtrlColorClass = true;
          }

          _this9.baretaino();

          _this9.disableMtrlAdd = true;
          _this9.disableMtrlType = true;
          _this9.emptyDisable = true;
        } else if (res.data.code === 2) {
          var mg = '该材料未存在，请把内容补充完整保存添加';
          var tp = 'error';

          _this9.$message({
            message: mg,
            type: tp
          });

          _this9.disableMtrlAdd = false;

          if (_this9.mqcdForm.mdrl_type === 0) {
            _this9.disableMtrlType = false;
          } else {
            _this9.disableMtrlType = true;
          }

          _this9.emptyDisable = true;
        } else {
          var _mg = res.data.msg;
          var _tp = 'error';

          _this9.$message({
            message: _mg,
            type: _tp
          });

          _this9.initData();
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this9.$message({
          message: mg,
          type: tp
        });
      });
    },
    // 匹配
    matchingMqcd: function matchingMqcd() {
      if (this.mqcdForm.mdrl_type === 0) {
        if (this.mqcdForm.mdrl_no && this.mqcdForm.mdrl_width && this.mqcdForm.mdrl_thick && this.mqcdForm.mdrl_color && this.mqcdForm.mdrl_weight) {
          this.getMtrlByInfo();
        } else {
          this.$message.warning('请把材料编号、材料门幅、材料毛高、材料克重和潘通色号补充完整');
        }
      } else {
        if (this.mqcdForm.mdrl_no && this.mqcdForm.mdrl_name && this.mqcdForm.mdrl_spec) {
          this.getMtrlByInfo();
        } else {
          this.$message.warning('请把材料编号、材料名称和材料规格补充完整');
        }
      }
    },
    // 清空
    emptyMqcd: function emptyMqcd() {
      this.resetForm('mqcdForm');
      this.emptyDisable = false;
    },
    // 材料导入
    mdrlImport: function mdrlImport() {
      this.mdrlFlag = true;
    },
    // 材料导入取消
    mdrlChanel: function mdrlChanel() {
      this.mdrlFlag = false;
    },
    falseMtrl: function falseMtrl() {
      this.mdrlChanel();
    },
    // 材料导入确认
    mdrlConfirm: function mdrlConfirm(val) {
      console.log(val);
      var value = JSON.parse(JSON.stringify(val));
      this.mqcdForm = Object.assign(this.mqcdForm, value);
      this.mqcdForm.sour_no = null;
      var urlEng = JSON.parse(JSON.stringify(this.mqcdForm.imge_url));
      var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
      this.mqcdForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
      this.mqcdForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      this.emptyDisable = true;
      this.mdrlFlag = false;
    },
    // 采购材料明细导入
    sourImport: function sourImport() {
      this.sourFlag = true;
    },
    // 采购材料取消
    sourChanel: function sourChanel() {
      this.sourFlag = false;
    },
    falseSour: function falseSour() {
      this.sourChanel();
    },
    // 采购材料明细导入确认
    sourConfirm: function sourConfirm(val) {
      var value = JSON.parse(JSON.stringify(val));
      this.mqcdForm = Object.assign(this.mqcdForm, value);
      var urlEng = JSON.parse(JSON.stringify(this.mqcdForm.imge_url));
      var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
      this.mqcdForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
      this.mqcdForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);

      if (!this.mqcdForm.colr_class) {
        this.disableMtrlColorClass = false;
      } else {
        this.disableMtrlColorClass = true;
      }

      this.baretaino();
      this.emptyDisable = true;
      this.mdrlFlag = false;
      this.sourFlag = false;
    },
    //表单重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.mqcdForm.imge_url = null;
      this.mqcdForm.imge_urlO = null;
      this.mqcdForm.imge_id = null;
      this.disableMtrlAdd = true;
      this.disableMtrlType = true;
      this.emptyDisable = false;
    },
    mdrlColorInput: function mdrlColorInput() {
      this.mqcdForm.mdrl_color = this.helper.keepTNum(this.mqcdForm.mdrl_color);
      this.mqcdForm.mdrl_color = this.mqcdForm.mdrl_color.substr(0, 4);
    },
    // 材料编号失去焦点匹配颜色大类
    changeMtrlColor: function changeMtrlColor() {
      if (this.mqcdForm.mdrl_type === 0 && this.mqcdForm.mdrl_color.length !== 0) {
        this.clickSyncColor();
      }
    },
    //同步颜色 大类
    clickSyncColor: function clickSyncColor() {
      var _this10 = this;

      get(colrAPI.getColrClassByPantone, {
        colr_pantone: this.mqcdForm.mdrl_color + 'C'
      }).then(function (res) {
        if (res.data.code === 0) {
          _this10.mqcdForm.colr_class = res.data.data.form.colr_class;
          _this10.disableMtrlColorClass = true; //  this.$message.success('同步'+res.data.msg)

          return;
        } else if (res.data.code === 2) {
          _this10.mqcdForm.colr_class = null;

          _this10.$message.warning('未匹配到该颜色大类');

          _this10.disableMtrlColorClass = false;
          return;
        }

        _this10.$message.warning(res.data.msg);
      }).catch(function (res) {
        _this10.$message.warning(res.data.msg);
      });
    },
    // 材料编号截取
    mdrlNoInput: function mdrlNoInput() {
      this.mqcdForm.mdrl_no = this.helper.keepEnglish(this.mqcdForm.mdrl_no).toUpperCase();
      this.mqcdForm.mdrl_no = this.mqcdForm.mdrl_no.substr(0, 2);
    },
    // 成功上传
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      if (res.code === 0) {
        if (this.imgTypeFlag) return this.$message.warning('仅支持jpg、png、jpeg格式的图片');
        var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        var urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.mqcdForm.imge_id = res.data.imge_id;
        this.mqcdForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
        this.mqcdForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 上传头像前
    beforeAvatarUpload: function beforeAvatarUpload(res) {
      this.imgTypeFlag = false;
      var str = res.name.substr(res.name.indexOf('.') + 1, res.name.length);
      var imgTypeList = ['jpg', 'png', 'jpeg'];
      if (imgTypeList.indexOf(str) === -1) this.imgTypeFlag = true;
    }
  }
};